/**
 * Tone tokens used by `UserHeaderTag` to colour the small pill chips
 * rendered next to the user's name (Figma 5747:1691). Kept as a
 * frozen constant so the available tones stay enumerable and the
 * lookup keys can never drift between the SCSS module and the JSX.
 */
export const USER_TAG_TONES = Object.freeze({
    PRIMARY: 'primary',
    NEUTRAL: 'neutral',
    INFO: 'info',
});

/**
 * Page size for a connection's event history. Matches the admin API's own
 * `PAGINATION.PER_PAGE_DEFAULT`, so "Show more" pages line up with what the
 * endpoint would have returned unasked.
 */
export const CONNECTION_EVENTS_PER_PAGE = 20;
